import { Box, useTheme } from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';

import { usePortalConfiguration } from '@frontend/utils';

const QR_CODE_BG_COLOR = '#FFFFFF';
const QR_CODE_FG_COLOR = '#000000';
const DEFAULT_SCALE = 75;

export interface QrCodeDisplayProps {
  value: string;
  scale?: number;
}

export const QrCodeDisplay = ({ value, scale }: QrCodeDisplayProps) => {
  const theme = useTheme();
  const { config } = usePortalConfiguration();

  const resolvedScale = scale ?? config.qrConfig?.scale ?? DEFAULT_SCALE;

  return (
    <Box
      maxWidth={`${resolvedScale}%`}
      p={2}
      border={`1px solid ${theme.palette.divider}`}
      borderRadius="16px"
      bgcolor={QR_CODE_BG_COLOR}
    >
      <QRCodeSVG
        value={value}
        height="100%"
        width="100%"
        bgColor={QR_CODE_BG_COLOR}
        fgColor={QR_CODE_FG_COLOR}
        level="L"
      />
    </Box>
  );
};
